import { Box, Button, Typography } from "@mui/material";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

const PrivacyPolicy: FC = () => {
    const navigate = useNavigate();
    return (
        <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "100vw", minHeight: "76vh" }}>
            <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "60vw" }}>
            <Typography variant="h3" align="center" mb={2}>Privacy Policy</Typography>
            <Typography variant="body1" align="center">
                In the future you'll find our updated privacy policy here. For now, you can download the our current privacy policy by clicking the button below.
            </Typography>
            <Button
                sx={{ mt: 2 }}
                variant="outlined"
                href="https://firebasestorage.googleapis.com/v0/b/stage-propile.appspot.com/o/docs%2FPrivacy-verklaring-Re-Evented-v1.1.pdf?alt=media&token=9086aa98-5ca6-40cc-9267-a62014f911e2"
                download>
                Download Privacy Policy
            </Button>
            <Button
                sx={{ mt: 3 }}
                variant="contained"
                onClick={() => navigate("/register")}>
                Go back to registration
            </Button>
            </Box>
        </Box>
    );
};

export default PrivacyPolicy;